module.exports = __webpack_public_path__ + "img/SKMJ_heavy7.8357b93d.jpg";